import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KTSVG } from "../../../_metronic/helpers";
import { ExternalUserInitialsForAdd, ExternalUserInitialsForUpdate } from "./interfaces/ExternalUserClass";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    addExternalUserAsync, updateExternalUserAsync, resetSelectedRecordObjectInState
    
} from "./externalUserSlice";

import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from "react-i18next";
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import CanvasLoader from "../../../common/CanvasLoader";
import { ShowSwalForCanvas } from "../../../common/SweetAlert";
import { GetEmailAddressValidationAsync } from "../employee/employeeSlice";



export const ExternalUserForm = (props: any) => {

    //const { modelRef } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(ExternalUserInitialsForAdd)
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    //const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>();
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    // const [selectedOptionExternalUser, setselectedOptionExternalUser] = useState<{ [object: string]: any }>();
    const [selectedOptionExternalUser, setselectedOptionExternalUser] = useState<{ value: string; label: string } | null>(null);
    const [TimeZonesArray, SetTimeZonesArray] = useState<any | ''>([]);
    const [ExternalUserArray, SetExternalUserArray] = useState<any | ''>([]);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.externalUser);
    const dispatch = useAppDispatch();
    const { maxMenuHeight, manageTerminologyList } = useAppSelector(state => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const { t } = useTranslation();
    const [accountemployeeid, setAccountemployeeid] = useState<number | null>(null);
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);
    const [showErrorSummary, setShowErrorSummary] = useState(false);
        const [isEmailAvailabler, setisEmailAvailabler] = useState(true);
        const [emailvalidate, setEmailValidate]=useState(true);
   const formikRef = useRef<any>(null);
   const [showPassword, setShowPassword] = useState(false);
       const [showConfirmPassword, setShowConfirmPassword] = useState(false);


    const { enablePasswordComplexity } = useAppSelector((state) => state.globalState);
    const getTimeZonesAsync = async () => {
        const response = await fetchAPI("api/DropDown/GetTimeZones", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.SystemTimeZoneId;
            item.label = item.TimeZoneName;
            delete item.SystemTimeZoneId;
            delete item.TimeZoneName;
        });
        SetTimeZonesArray(json);
        setIsCanvasLoader(false);
    }

    useEffect(() => {
        getTimeZonesAsync();
    }, [])

    const getExternalUserAsync = async () => {
        const response = await fetchAPI("api/Clients/GetActiveClients", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.AccountClientId;
            item.label = item.ClientName;
            delete item.AccountClientId;
            delete item.ClientName;
        });
        SetExternalUserArray(json);
    }

    useEffect(() => {
        getExternalUserAsync();
    }, [])


    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(ExternalUserInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            setAccountemployeeid(tempObj.AccountEmployeeId)

            setCurrentFieldsData(stateItem);
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            stateItem.IsEmailVerified = stateItem.IsEmailVerified === 'Yes' ? true : false;
            setSelectedOptionDropDown(TimeZonesArray.find((TimeZone: any) => TimeZone.value == stateItem.EmployeeTimeZoneId));
            setselectedOptionExternalUser(ExternalUserArray.find((ExternalUser: any) => ExternalUser.value == stateItem.ExternalUserClientId));
            setIsCanvasLoader(false);
        }
        else {
            // setSelectedOptionDropDown({value:-1,label:''});  
            // setselectedOptionExternalUser({value:-1,label:''});  
            setAccountemployeeid(0)
            setSelectedOptionDropDown(TimeZonesArray[0]);
            setselectedOptionExternalUser( ExternalUserArray[0]);
            setCurrentFieldsData(ExternalUserInitialsForAdd);
           
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        if (formikRef.current) {
            setShowErrorSummary(false);
            setEmailValidate(true)
            formikRef.current.resetForm();
        }
    }, [selectedRecord])

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const handleTimeZoneChange = (data: any) => {
        const { value, label } = data;
        setSelectedOptionDropDown(TimeZonesArray.find((TimeZone: any) => TimeZone.value === value));
        setCurrentFieldsData({ ...currentFieldsData, 'TimeZoneId': value });
    };
    const handleExternalUserChange = (data: any) => {
        const { value, label } = data;
        setselectedOptionExternalUser(ExternalUserArray.find((ExternalUser: any) => ExternalUser.value === value));
        setCurrentFieldsData({ ...currentFieldsData, 'ExternalUserClientId': value });
    };

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            const { verifyPassword, ...updatedValues } = values;
            dispatch(updateExternalUserAsync(updatedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("External User Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");                    
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addExternalUserAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    if (originalPromiseResult.StatusCode === "403") {
                        ShowToast('warning', originalPromiseResult.ResponseMessage, "warning", "toast-top-right");
                        return;
                    }
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("External User Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const handleCloseOnClickEvent = () => {
        setShowErrorSummary(false);
        dispatch(resetSelectedRecordObjectInState());
    }
    // const handleBlur = async (setFieldTouched: any, e: any, values: any) => {
    //     e.persist(); // Persist the synthetic event to use it in the async function

    //     setFieldTouched('EMailAddress');
    //     //console.log('handleBlur',isValid);
    //     // Perform your API call here
    //     try {
    //         if (e.target.value !== '') {
    //             dispatch(GetEmailAddressValidationAsync({ EMailAddress: e.target.value, AccountEmployeeId: values.AccountEmployeeId === undefined ? 0 : values.AccountEmployeeId }));
    //         }
    //         // Process the API response data as needed
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //         // Handle the error appropriately
    //     }
    // };


const handleBlurValidateAll = async (setFieldTouched: any, values: any, validateForm: any, e: any = null) => {
        if (e) {
            if (e.target) {
                const fieldName = e.target.name;
                const fieldValue = e.target.value;
                setEmailValidate(true)
                try {
                    if (fieldValue !== '') {
                        dispatch(GetEmailAddressValidationAsync({ EMailAddress: fieldValue, AccountEmployeeId: accountemployeeid === undefined ? 0 : accountemployeeid })).then((result) => {
                            setisEmailAvailabler(result.payload);
                            setFieldTouched("emailAddress", result.payload);
                            if (!result.payload) {
                                setEmailValidate(result.payload)
                                // ShowSwalForCanvas('Email Address', fieldValue + ' Email is already taken', 'warning');
                                return;
                            }
                        }).catch((error) => {
                        });
                    }
                } catch (error) {
                }
            }
        }
        // Mark all fields as touched
        //Object.keys(values).forEach(field => {
           // setFieldTouched(field, true);
       // });
        // Validate all fields
       // validateForm();
    }
      const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  }

  const toggleConfirmPasswordVisibility =()=>{
    setShowConfirmPassword(!showConfirmPassword)
  }
    return (
        <>
            <Formik  
             innerRef={formikRef}
                initialValues={{
                    ...currentFieldsData,
                    TimeZoneId: selectedOptionDropDown?.value || "",
                    ExternalUserClientId: selectedOptionExternalUser?.value || "",

                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape(enablePasswordComplexity ? {
                    EMailAddress: yup.string()
                    .matches(
                        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        'Invalid email format'
                    )
                    .required('Email is required'),
                    Password: accountemployeeid
                        ? yup
                            .string()
                            .min(6, t('Password must be at least 6 characters'))
                        : yup
                            .string()
                            .min(6, t('Password must be at least 6 characters'))
                            .required(t('Password is required')),  
                    FirstName: yup
                        .string()
                        .label(t('First Name'))
                        .required(),
                    LastName: yup
                        .string()
                        .label(t('Last Name'))
                        .required(),
                    verifyPassword: accountemployeeid
                        ? yup
                            .string()
                            .oneOf([yup.ref('Password')], t('Passwords do not match'))
                            .nullable()
                        : yup
                            .string()
                            .oneOf([yup.ref('Password')], t('Passwords do not match'))
                            .nullable()
                            .required(t('Password verification is required')),
                    ExternalUserClientId: yup
                                            .string()
                                            .required(getValueFromResource('Client is required', dispatch, t))
                                            .test('not-zero', getValueFromResource('Client is required', dispatch, t), value => value !== '0'),

                } : {
                    EMailAddress: yup.string()
                    .matches(
                        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        'Invalid email format'
                    )
                    .required('Email is required'),
                    Password: accountemployeeid
                        ? yup
                            .string()
                        : yup
                            .string()
                            .required(t('Password is required')),    
                    FirstName: yup
                        .string()
                        .label(t('First Name'))
                        .required(),
                    LastName: yup
                        .string()
                        .label(t('Last Name'))
                        .required(),
                    verifyPassword: accountemployeeid
                        ? yup
                            .string()
                            .oneOf([yup.ref('Password')], t('Passwords do not match'))
                            .nullable()
                        : yup
                            .string()
                            .oneOf([yup.ref('Password')], t('Passwords do not match'))
                            .nullable()
                            .required(t('Password verification is required')),
                    ExternalUserClientId: yup
                            .string()
                            .required(getValueFromResource('Client is required', dispatch, t))
                            .test('not-zero', getValueFromResource('Client is required', dispatch, t), value => value !== '0'),
                }
                )}>

                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, handleBlur,setFieldValue,validateForm }) => (
                    <Fragment>

                        <div className='card-body card-pad  '>
                            {isCanvasLoader ? <CanvasLoader /> : <>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className='row'>
                                            <div className="col-md-12 mb-2">
                                                <label className="required form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Email Address')} */}
                                                    {getValueFromResource('Email Address',dispatch, t)}
                                                    </label>
                                                <input
                                                    id="EMailAddress"
                                                    value={values.EMailAddress}
                                                    type="text"
                                                    className="form-control fs-7 fw-normal"
                                                    placeholder=
                                                    // {t('Email Address')}
                                                    {getValueFromResource('Email Address',dispatch, t)}
                                                    autoCapitalize="none"
                                                    // onChange={handleChange('EMailAddress')}
                                                    onChange={(e)=>{
                                                        handleChange(e);
                                                        setEmailValidate(true)
                                                    }}
                                                    ref={defaultFocusRef}
                                                    onBlur={(e: any) => handleBlurValidateAll(setFieldTouched, values, validateForm, e)}
                                                    // onBlur={() => setFieldTouched('EMailAddress')}
                                                />
                                                <div style={{ paddingRight: 20 }}>
                                                    {!emailvalidate ? (
                                                        <p className='errorMsg'>{"Email is already taken"}</p>
                                                    ) :  touched.EMailAddress && errors.EMailAddress &&
                                                        <p className='errorMsg'>{errors.EMailAddress as string}</p>
                                                    }
                                                </div>

                                            </div>

                                            <div className="col-md-6 mb-2 mt-2">
                                                <label className="form-label fs-7 fw-normal">
                                                    {/* {t('First Name')} */}
                                                    {getValueFromResource('First Name',dispatch, t)}
                                                    </label>
                                                <input
                                                    type="text"
                                                    name="FirstName"
                                                    className="form-control fs-7 fw-normal"
                                                    value={values.FirstName}
                                                    onChange={handleChange('FirstName')}
                                                        
                                                />
                                                <div>
                                                    {touched.FirstName && errors.FirstName &&
                                                        <p className='errorMsg'>{errors.FirstName as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2 mt-2">
                                                <label className="form-label fs-7 fw-normal">
                                                    {/* {t('Last Name')} */}
                                                    {getValueFromResource('Last Name',dispatch, t)}
                                                    </label>
                                                <input
                                                    type="text"
                                                    name="LastName"
                                                    className="form-control fs-7 fw-normal"
                                                    value={values.LastName}
                                                    onChange={handleChange('LastName')}
                                                    // onBlur={() => setFieldTouched('LastName')}
                                                />

                                                <div>

                                                    {touched.LastName && errors.LastName &&
                                                        <p className='errorMsg'>{errors.LastName as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2 mt-2">
                                                <label className="form-label fs-7 fw-normal">
                                                    {/* {t('Password')} */}
                                                    {getValueFromResource('Password',dispatch, t)}
                                                    </label>
                                                 <div className="wrapper">

                                                <input
                                                    // type="password"
                                                     type={showPassword ? 'text' : 'password'}
                                                    className="form-control fs-7 fw-normal"
                                                    name="password"
                                                    value={values.Password}
                                                    onChange={handleChange('Password')}
                                                    onBlur={() => setFieldTouched('Password')}
                                                    autoComplete="new-password"
                                                    />
                                                     <span
                                                            className="insideField-Icons form-label fs-6 fw-normal cursor"
                                                            onClick={togglePasswordVisibility}
                                                        >
                                                            {showPassword ? (
                                                                <i className="bi bi-eye-slash-fill text-gray"></i>
                                                            ) : (
                                                                <i className="bi bi-eye-fill text-gray"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                <div>
                                                    {touched.Password && errors.Password &&
                                                        <p className='errorMsg'>{errors.Password as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2 mt-2">
                                                <label className="form-label fs-7 fw-normal">
                                                    {/* {t('Verify Password')} */}
                                                    {getValueFromResource('Verify Password',dispatch, t)}
                                                    </label>
                                                <div className="wrapper">
                                                <input
                                                    // type="password"
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    className="form-control fs-7 fw-normal"
                                                    name="verifyPassword"
                                                    value={values.VerifyPassword}
                                                    onChange={handleChange('verifyPassword')}
                                                    onBlur={() => setFieldTouched('verifyPassword')}
                                                    autoComplete="new-password"
                                                    />
                                                     <span
                                                            className="insideField-Icons form-label fs-6 fw-normal cursor"
                                                            onClick={toggleConfirmPasswordVisibility}
                                                        >
                                                            {showConfirmPassword ? (
                                                                <i className="bi bi-eye-slash-fill text-gray"></i>
                                                            ) : (
                                                                <i className="bi bi-eye-fill text-gray"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                <div>
                                                    {touched.verifyPassword && errors.verifyPassword &&
                                                        <p className='errorMsg'>{errors.verifyPassword as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2 mt-2">
                                                <label className="form-label fs-7 fw-normal">
                                                    {/* {t('Time Zone')} */}
                                                    {getValueFromResource('Time Zone',dispatch, t)}
                                                    </label>

                                                <Select
                                                    value={
                                                        values.TimeZoneId ?
                                                            TimeZonesArray.find((option: any) => option.value == values.TimeZoneId) :
                                                            TimeZonesArray[0]
                                                    }
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="TimeZoneId"
                                                    id="TimeZoneId"
                                                    onBlur={() => setFieldTouched('TimeZoneId', true)}
                                                    onChange={(selectedOption) => {
                                                        handleChange({
                                                            target: {
                                                                id: "TimeZoneId",
                                                                value: selectedOption?.value
                                                            },
                                                        });
                                                    }}
                                                    options={TimeZonesArray}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}/>                                               

                                                <div >
                                                    {touched.TimeZoneId && errors.TimeZoneId &&
                                                        <p className='errorMsg'>{errors.TimeZoneId as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2 mt-2">
                                                <label className="form-label fs-7 fw-normal">
                                                    {/* {t('External User Client')} */}
                                                    {getValueFromResource('External User Client',dispatch, t)}
                                                    </label>
                                                <Select
                                                    value={
                                                        values.ExternalUserClientId ?
                                                            ExternalUserArray.find((option: any) => option.value == values.ExternalUserClientId) :
                                                            ExternalUserArray[0]
                                                    }
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="ExternalUserClientId"
                                                    id="ExternalUserClientId"
                                                    onBlur={() => setFieldTouched('ExternalUserClientId', true)}
                                                    onChange={(selectedOption) => {
                                                        handleChange({
                                                            target: {
                                                                id: "ExternalUserClientId",
                                                                value: selectedOption?.value
                                                            },
                                                        });
                                                    }}
                                                    options={ExternalUserArray}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />                                           

                                                <div >
                                                    {touched.ExternalUserClientId && errors.ExternalUserClientId &&
                                                        <p className='errorMsg'>{errors.ExternalUserClientId as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            {Object.keys(selectedRecord).length > 0 ? (
                                                <div className="col-md-6 mt-3">
                                                    <label className="form-label">
                                                        {/* {t('Disabled')} */}
                                                        {getValueFromResource('Disabled',dispatch, t)}
                                                        </label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input h-20px w-30px"
                                                            type="checkbox"
                                                            checked={values.IsDisabled}
                                                            id="IsDisabled"
                                                            name="IsDisabled"
                                                            onChange={handleChange('IsDisabled')}
                                                        />
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </>
                                }
                                {showErrorSummary && Object.keys(errors).length > 0 && (
                        <div className="mt-3 alert alert-danger">
                            <strong>
                                {/* {t('Error Summary')}: */}
                                {getValueFromResource('Error Summary',dispatch, t)}:
                                </strong>
                            <ul>
                                {Object.keys(errors).map((fieldName, index) => (
                                    <li key={index}>{errors[fieldName] as string}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                            </>
                            }
                            
                        </div>

                        <div className='card-footer pt-4'>
                            <div className='d-flex flex-stack float-end'>
                                    <button
                                        ref={closeButtonRef}
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                        id="kt_OffCanvas"
                                        onClick={handleCloseOnClickEvent}
                                    >
                                        {/* {t('Cancel')} */}
                                        {getValueFromResource('Cancel',dispatch, t)}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                        onClick={() => { setShowErrorSummary(true); 
                                            handleSubmit();
                                        }}
                                        // onClick={() => handleSubmit()}
                                        disabled={!isEmailAvailabler}
                                        data-kt-element='send'
                                    >
                                        {/* {t('Save')} */}
                                        {getValueFromResource('Save',dispatch, t)}
                                    </button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>

    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}